<div class="container">
  <h3>{{ 'fidelity-info.loyalty-advantage.title' | translate }}</h3>
  <div class="d-flex">
    <svg><use xlink:href="assets/img/icons.svg#ccastomax"></use></svg>
    @if (!isLoading) {
      <div
        class="d-flex"
        [innerHtml]="
          'fidelity-info.loyalty-advantage.detail-combined'
            | translate
              : {
                  detail0: ('fidelity-info.loyalty-advantage.detail0' | translate),
                  detail1:
                    ('fidelity-info.loyalty-advantage.detail1'
                    | translate
                      : {
                          nombrePointGagne: fidelityCardPointSimulationInfo.freeCardEarnedPoints,
                        }),
                  detail2:
                    fidelityCardPointSimulationInfo.premiumCardCoupons.length > 0
                      ? ('fidelity-info.loyalty-advantage.detail2' | translate)
                      : '',
                  detail5:
                    fidelityCardPointSimulationInfo.premiumCardCoupons.length > 0
                      ? ('fidelity-info.loyalty-advantage.detail5'
                        | translate
                          : {
                              couponDescription: fidelityCardPointSimulationInfo.premiumCardRewards,
                              withCard: isFreeCard(fidelityCardPointSimulationInfo.type)
                                ? ('fidelity-info.loyalty-advantage.detail6' | translate)
                                : ('fidelity-info.loyalty-advantage.detail7' | translate),
                            })
                      : '',
                  detail3:
                    !isPremium(fidelityCardPointSimulationInfo.type) &&
                    fidelityCardPointSimulationInfo.freeCardCoupons.length > 0
                      ? ('fidelity-info.loyalty-advantage.detail3'
                        | translate
                          : {
                              couponDescription: fidelityCardPointSimulationInfo.freeCardRewards,
                            })
                      : '',
                  detail4:
                    !isPremium(fidelityCardPointSimulationInfo.type) &&
                    fidelityCardPointSimulationInfo.premiumCardCoupons.length > 0
                      ? ('fidelity-info.loyalty-advantage.detail4' | translate)
                      : ('fidelity-info.loyalty-advantage.detail4-bis' | translate),
                }
        "></div>
    } @else {
      <div class="skeleton"><p-skeleton height="2rem" width="40rem" /></div>
    }
  </div>
</div>
